import { connect } from 'react-redux';
import bookingStateSelector from '../../../../selectors/BookingStateSelector';
import requirementsSelector from '../../AppointmentRequirementsSelector';
import {
    USING_INSURANCE_STATE_KEY,
    USING_INSURANCE_WARNING,
} from '../../constants';
import { getRequirement } from '../../helpers';
import {
    clickCheckbox,
    trackClickUsingInsuranceWarning,
} from './usingInsuranceConfirmationActions';
import View from './usingInsuranceConfirmationView';

export const mapStateToProps = (state) => {
    const bookingState = bookingStateSelector(state);
    const usingInsuranceRequirements =
        bookingState &&
        bookingState.requirements &&
        getRequirement(USING_INSURANCE_WARNING, bookingState.requirements);
    const shouldShowCheckbox = !!usingInsuranceRequirements;

    const requirements = requirementsSelector(state);

    return {
        shouldShowCheckbox,
        isChecked: requirements[USING_INSURANCE_STATE_KEY].value,
        invalidMessage: requirements[USING_INSURANCE_STATE_KEY].error,
    };
};

export const mapDispatchToProps = (dispatch) => ({
    clickUsingInsuranceWarning: (isChecked) => {
        dispatch(clickCheckbox(isChecked));
        dispatch(trackClickUsingInsuranceWarning());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
